export enum LanguageSupportedLocale {
    "en" = "en",
    "nl" = "nl",
    "de" = "de",
}
